import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { IDeploySensitivityWeighting } from '../interfaces/deploy-priority/deploy-sensitivity-weighting';

@Injectable({
  providedIn: 'root',
})
export class DeploySensitivityWeightingService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getCurrentWeighting(): Promise<IDeploySensitivityWeighting> {
    const url = '/api/DeployPriority/DeploySensitivityScoreWeighting';

    return this.handleRequest<any>(
      this.http.get<IDeploySensitivityWeighting>(url),
      this.handlersFactory.getForReadAll(),
    );
  }

  updateWeighting(dto: IDeploySensitivityWeighting): Promise<void> {
    const url = '/api/DeployPriority/DeploySensitivityScoreWeighting';

    return this.handleRequest<void>(
      this.http.post<void>(url, dto),
      this.handlersFactory.getForReadAll(),
    );
  }
}
